import { Component, OnDestroy, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { AuthenticationService } from '@app/core/authentication/authentication.service';
import { LoginService } from '@app/core/services/api';
import { OidcSecurityService } from 'angular-auth-oidc-client';
import { Subscription } from 'rxjs';

export interface IDataFABMenu {
  name: string;
  nameInitials: string;
  profile: string;
}

@Component({
  selector: 'app-maresel-header-logo',
  templateUrl: './maresel-header-logo.component.html',
  styleUrls: ['./maresel-header-logo.component.scss']
})
export class MareselHeaderLogoComponent implements OnInit, OnDestroy {
  subscription!: Subscription;
  isAuthorized = false;
  userData: any;
  fabMenuData: IDataFABMenu = { name: '', nameInitials: '', profile: '' };
  // nameInitials: string;
  constructor(
    public oidcSecurityService: OidcSecurityService,
    private authenticationService: AuthenticationService,
    private loginService: LoginService,
    private router: Router
  ) {}

  ngOnInit(): void {
    this.subscription = this.oidcSecurityService.isAuthenticated$.subscribe(async (data) => {
      const oktaAuth = data?.allConfigsAuthenticated?.find((c: any) => c.configId === 'OKTA');
      const azureAuth = data?.allConfigsAuthenticated?.find((c: any) => c.configId === 'AZURE');


      if ((oktaAuth?.isAuthenticated || azureAuth?.isAuthenticated) && this.router.url !== '/login') {
        let roles: any;
        try {
          roles = await this.loginService.rolUserGet().toPromise();
        } catch (error: any) {
          roles = error?.error;
        }
        if (roles && Array.isArray(roles) && roles.length) {
          this.isAuthorized = true;

          this.authenticationService.setUserRole(roles);

          const cachedUserData = localStorage.getItem('maresel_user_data');
          if (cachedUserData) {
            try {
              this.userData = JSON.parse(cachedUserData);
              this.getFABMenuData();
            } catch (e) {
              console.error('Error parseando cached user data:', e);
            }
          }

          const idToken = this.authenticationService.currentIdTokenForDisplay;
          if (idToken) {
            try {
              const base64Url = idToken.split('.')[1];
              const base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/');
              this.userData = JSON.parse(window.atob(base64));

              localStorage.setItem('maresel_user_data', JSON.stringify(this.userData));

              this.getFABMenuData();
            } catch (e) {
              console.error('Error decodificando ID token:', e);
            }
          }
        } else {

          this.isAuthorized = false;
          this.userData = null;
          localStorage.removeItem('maresel_user_data');

          if (this.router.url !== '/unauthorized') {
            const errorKey = (roles as any)?.err?.key || 'ERROR.USER.NOT.AUTHORIZED';
            sessionStorage.setItem('UNAUTHORIZED_ERROR_KEY', errorKey);
            this.router.navigateByUrl('/unauthorized');
          }
        }
        return;
      }
      if (this.authenticationService.currentTokenValue) {
        const tokenCheck = this.authenticationService.checkToken(this.authenticationService.currentTokenValue);
        if (!tokenCheck || !tokenCheck.valid) {
          console.warn('Token expirado detectado en header. Haciendo logout...');
          this.isAuthorized = false;
          this.authenticationService.localLogOut();
        } else if (this.authenticationService.getRoles().length === 0) {

          this.isAuthorized = false;
        } else if (this.router.url !== '/login') {
          this.isAuthorized = true;
          this.userData = this.authenticationService.decodeJwt(this.authenticationService.currentTokenValue);
          this.getFABMenuData();
        } else {
          this.isAuthorized = false;
        }
      } else if (this.router.url === '/login') {
        this.isAuthorized = false;
      }
    });
  }

  ngOnDestroy() {
    this.subscription.unsubscribe();
  }

  getFABMenuData() {
    const name = this.resolveDisplayName(this.userData);
    const profile = this.authenticationService.getRoles()[0];
    this.fabMenuData = { name, profile, nameInitials: this.letterName(name) };
  }

  letterName(name: string): string {
    if (!name) {
      return '';
    }
    const trimmed = name.trim();
    if (!trimmed) {
      return '';
    }

    // Formato legado: "Apellido, Nombre"
    const commaParts = trimmed.split(',');
    if (commaParts[1]) {
      return (commaParts[0][0] + commaParts[1].trim()[0]).toUpperCase();
    }

    // Fallback: "Nombre Apellido" o email/sub
    const spaceParts = trimmed.split(' ').filter((part: string) => part.length > 0);
    if (spaceParts.length >= 2) {
      return (spaceParts[0][0] + spaceParts[1][0]).toUpperCase();
    }

    return trimmed[0].toUpperCase();
  }

  private resolveDisplayName(userData: any): string {
    if (!userData) {
      return '';
    }
    return userData.name || userData.preferred_username || userData.email || userData.sub || '';
  }
}
